/* @ngInject */
const searchCtrl = (
  $scope,
  storageHandler,
  // $$list
) => {
  // $scope.wagons = storageHandler.get('wagons-list-1')
}

export default searchCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/search/search.controller.js